import React from "react";
import { BusinessExpert, BusinessMerchant, BusinessClient } from "./index.jsx";
import { isMerchantType } from "../../helpers/Data";

const BusinessForm = ({ type, user, isProfile, isRC }) => {
  // Merchant / Personal Shopper / Supplier / Watchmaker — see MERCHANT_TYPES.
  if (isMerchantType(type)) {
    return <BusinessMerchant user={user} isProfile={isProfile} isRC={isRC} />;
  }

  if (type === "expert" || type === "concierge") {
    return <BusinessExpert user={user} isProfile={isProfile} isRC={isRC} />;
  }

  // Default / client (also used on create before type is chosen)
  return <BusinessClient user={user} isProfile={isProfile} isRC={isRC} />;
};

export default BusinessForm;
